import { fetchApi } from '../../../lib/fetchApi';
import { ClaimFollowUpCommentListDto, ClaimFollowUpCommentDto } from '../types';

const BASE_URL = "/claimFollowUpComment"

export const getClaimFollowUpComments = async (claimId: number): Promise<ClaimFollowUpCommentListDto[]> => {
    const response = await fetchApi.get(`${BASE_URL}/byClaim/${claimId}`) as ClaimFollowUpCommentListDto[];
    
    return response;
};

export const saveClaimFollowUpComment = async (claimFollowUpId: number, body: ClaimFollowUpCommentDto): Promise<void> => {
    const formData = new FormData();

    formData.append('claimId', body.claimId.toString());
    formData.append('comment', body.comment ?? '');

    if (body.typeId !== undefined && body.typeId !== null) {
        formData.append('typeId', body.typeId.toString());
    }

    body.claimFiles?.forEach((cf) => {
        formData.append('claimFiles', cf.id!.toString());
    });

    body.files?.forEach((file) => {
        formData.append('files', file);
    });

    await fetchApi.post(`${BASE_URL}/${claimFollowUpId}`, formData);
};

export const deleteComment = async (commentId: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/delete/${commentId}`);
};

export const editClaimFollowUpComment = async (commentId: string, body: ClaimFollowUpCommentDto): Promise<void> => {
    const formData = new FormData();

    formData.append('claimId', body.claimId.toString());
    formData.append('comment', body.comment ?? '');

    if (body.typeId !== undefined && body.typeId !== null) {
        formData.append('typeId', body.typeId.toString());
    }

    body.claimFiles?.forEach((cf) => {
        formData.append('claimFiles', cf.id!.toString());
    });

    body.files?.forEach((file) => {
        formData.append('files', file);
    });
    await fetchApi.put(`${BASE_URL}/edit/${commentId}`, formData);
};

export const getComementById = async (commentId: number): Promise<ClaimFollowUpCommentDto> => {
    const response  = await fetchApi.get(`${BASE_URL}/${commentId}`) as ClaimFollowUpCommentDto;
    return response;
};